module.exports = __webpack_public_path__ + "static/media/sedan.5d4a50e5.png";